import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useThemeStore } from '../../stores/theme';
import {
	CircleCheckIcon,
	InfoIcon,
	TriangleAlertIcon,
	OctagonXIcon,
	Loader2Icon,
} from 'lucide-react';

const Toaster = ({ ...props }: ToasterProps) => {
	const theme = useThemeStore((s) => s.theme);

	return (
		<Sonner
			theme={theme}
			className="toaster group"
			icons={{
				success: <CircleCheckIcon className="size-4" />,
				info: <InfoIcon className="size-4" />,
				warning: <TriangleAlertIcon className="size-4" />,
				error: <OctagonXIcon className="size-4" />,
				loading: <Loader2Icon className="size-4 animate-spin" />,
			}}
			style={
				{
					'--normal-bg': 'var(--popover)',
					'--normal-text': 'var(--popover-foreground)',
					'--normal-border': 'var(--border)',
					'--border-radius': 'var(--radius)',
					zIndex: 9999,
				} as React.CSSProperties
			}
			{...props}
		/>
	);
};

export { Toaster };
